<template lang="">
	<div class="relative z-30">
		<svg width="37" height="47" viewBox="0 0 37 47" fill="none" xmlns="http://www.w3.org/2000/svg" :style="'width:' + sizeStyle[0] + ';height:' + sizeStyle[1]">
			<path
				d="M36.449 18.6205C36.449 28.9044 18.2245 47 18.2245 47C18.2245 47 0 28.9044 0 18.6205C0 8.33669 8.15938 0 18.2245 0C28.2896 0 36.449 8.33669 36.449 18.6205Z"
				fill="white"
			/>
			<path
				d="M34.449 18.6205C34.449 20.6801 33.5082 23.3776 31.8443 26.438C30.2095 29.4449 28.0052 32.5735 25.763 35.4325C23.5266 38.2841 21.2851 40.8263 19.6002 42.6578C19.0827 43.2203 18.6187 43.7147 18.2245 44.1294C17.8303 43.7147 17.3663 43.2203 16.8488 42.6578C15.1639 40.8263 12.9224 38.2841 10.686 35.4325C8.44378 32.5735 6.23945 29.4449 4.60469 26.438C2.94082 23.3776 2 20.6801 2 18.6205C2 9.40051 9.30427 2 18.2245 2C27.1447 2 34.449 9.40051 34.449 18.6205Z"
				:stroke="colors[color]"
				stroke-opacity="0.53"
				stroke-width="4"
			/>
		</svg>
		<p class="absolute translate-y-[-50%] translate-x-[-50%] top-[50%] left-[50%] text-xl font-bold" v-if="numberChallenge > 0">
			{{numberChallenge}}
		</p>
        <div class="absolute translate-y-[-50%] translate-x-[-50%] top-[50%] left-[50%] text-xl font-bold">
			<Icon v-if="typeChallenge == 'question'" :size="20" 
				class="" :color="colors[color]">
				<Question />
			</Icon>
		</div>
		<div class="absolute translate-y-[-50%] translate-x-[-50%] top-[50%] left-[50%] text-xl font-bold">
			<Icon v-if="typeChallenge == 'flag'" :size="20" :color="colors[color]">
				<Flag />
			</Icon>
		</div>
	</div>
</template>
<script lang="ts" setup>
import { onMounted, ref } from 'vue';
import Icon from "@/components/common/Icon.vue"
import Question from "@/assets/icons/marker_question.svg"
import Flag from "@/assets/icons/flag-checkered-solid.svg"

const sizeStyle = ref([37,47])
onMounted(() => {
	if( props.size == "big")
	{
		sizeStyle.value = [55,70]
	}
})

const props = defineProps({
	typeChallenge: {
		type: String,
		default: ""
	},
    color: {
            type: String,
            default: '#34A853'
        },
	numberChallenge: {
		type: Number,
		default: -1
	},
	size:{
		type: String,
		default: "normal"
	}
})



const colors = {
    red:'#A83434',
    green: '#34A853',
	blue: '#3462A8',
	purple: '#6034A8'
}


</script>
<style lang=""></style>
